import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const ViewListingLink = ({ showListingLinkAtBottom, listingURL }) => {
  if ( showListingLinkAtBottom) {
    return <a href={listingURL} className="btn btn-secondary full-width"><FormattedMessage id="shared_components.view_listing_link.text" defaultMessage="View Space" /></a>;
  }
  return null;
};

export default ViewListingLink;
